export const POSITIVE = { id: 'positive', label: 'Positiva' };
export const NEGATIVE = { id: 'negative', label: 'Negativa' };
export const NOT_KNOWN = { id: 'not_known', label: 'Non nota' };
